

<template>
  <div class="invoiceManagement">
    <div class="main">
      <div class="top-search">
        <div class="item">
          <span>发票申请编号：</span>
          <div>
            <el-input v-model="applyNo" placeholder="单行输入"></el-input>
          </div>
        </div>
        <div class="item">
          <span>开票时间：</span>
          <div>
            <el-date-picker
              v-model="invoiceTime"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="item">
          <span>发票类型：</span>
          <div>
            <el-select v-model="type" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>是否完税：</span>
          <div>
            <el-select v-model="complateTax" placeholder="请选择">
              <el-option
                v-for="item in  taxOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span>红冲状态：</span>
          <div>
            <el-select v-model="redStatus" placeholder="请选择">
              <el-option
                v-for="item in inOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 30px;"></span>
          <el-button type="primary" @click="queryInvoicesPost()" size="small">搜索</el-button>
          <el-button type="danger" @click="reset" size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 100%"
        >
          <el-table-column prop="apply.type" label="发票类型" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoice_no" label="发票编号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoice_time" label="开票时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="month" label="所属月份" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="apply.invoice_amount" label="价税合计总额(元)" width="130" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="购买方" :show-overflow-tooltip="true">
            <template slot-scope="scope" v-if="scope.row.apply">
              <div>名称：{{scope.row.apply.merchant_name}}</div>
              <div>纳税人识别号：{{scope.row.apply.merchant_credit_code}}</div>
              <div>地址：{{scope.row.apply.merchant_addr}}</div>
              <div>电话：{{scope.row.apply.merchant_mobile}}</div>
              <div>开户行：{{scope.row.apply.merchant_bank}}</div>
              <div>账号：{{scope.row.apply.merchant_account}}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售方" :show-overflow-tooltip="true">
            <template slot-scope="scope" v-if="scope.row.apply">
              <div>名称：{{scope.row.apply.businessmen_name}}</div>
              <div>纳税人识别号：{{scope.row.apply.businessmen_credit_code}}</div>
              <div>地址：{{scope.row.apply.businessmen_addr}}</div>
              <div>电话：{{scope.row.apply.businessmen_mobile}}</div>
              <div>开户行：{{scope.row.apply.businessmen_bank}}</div>
              <div>账号：{{scope.row.apply.businessmen_account}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="complate_tax" label="是否完税" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="red_status" label="红冲状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="apply_no" label="发票申请编号" width="130" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" style="text-align: center;">
                    <el-dropdown-item>
                      <el-button
                        @click="handleClick(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >&emsp;查看&emsp;</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
      <el-dialog :visible.sync="dialogInvoice" :before-close="handleClose" width="1200px">
        <div class="dialog-header">
          <div :class="contentKey == 1 ? 'header-title' : ''" @click="contentKey = 1">发票</div>
          <div :class="contentKey == 2 ? 'header-title' : ''" @click="contentKey = 2">完税证明</div>
        </div>
        <div class="dialong-content" v-if="contentKey == 1">
          <img :src="invoiceImg" alt />
        </div>
        <div class="dialong-content" v-if="contentKey == 2">
          <img :src="taxVoucher" alt />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      dialogInvoice: false,
      contentKey: 1,
      tableData: [],
      typeOptions: [
        {
          value: "20",
          label: "增值税专用发票"
        },
        {
          value: "10",
          label: "普通发票"
        },
        {
          value: "30",
          label: "电子发票"
        }
      ],
      taxOptions: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "否"
        }
      ],
      inOptions: [
        {
          value: "4",
          label: "已红冲"
        },
        {
          value: "1",
          label: "未红冲"
        },
        {
          value: "2",
          label: "红冲办理中"
        },
        {
          value: "3",
          label: "未红失败"
        }
      ],
      total: 0,
      pageSzie: 10,
      complateTax: "",
      invoiceTime: "",
      applyNo: "",
      redStatus: "",
      type: "",
      //
      invoiceImg: "",
      taxVoucher: ""
    };
  },
  mounted() {
    this.queryInvoicesPost();
  },
  methods: {
    reset() {
      this.complateTax = "";
      this.invoiceTime = "";
      this.redStatus = "";
      this.applyNo = "";
      this.type = "";
      this.queryInvoicesPost();
    },
    queryInvoicesPost(size) {
        const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.queryInvoices, {
        pageIndex: size || 1,
        pageSize: this.pageSzie,
        complateTax: this.complateTax,
        invoiceTime: this.invoiceTime,
        applyNo: this.applyNo,
        redStatus: this.redStatus,
        type: this.type
      }).then(
        d => {
          console.log(d, "ddddddddddddddddd");
           loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.tableData = d.data.rows;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClick(row) {
      console.log(row);
      post(api.queryInvoice, {
        id: row.id
      }).then(
        d => {
          console.log(d);
          if (d.status === 0) {
            console.log(d, "????????????");
            this.dialogInvoice = true;
            this.invoiceImg = d.data.invoice.invoiceImg;
            this.taxVoucher = d.data.invoice.taxVoucher;
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClose(done) {
      done();
    },
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.queryInvoicesPost();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
      this.queryInvoicesPost(val);
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.invoiceManagement {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
    .dialog-header {
      width: 100%;
      height: 49px;
      line-height: 49px;
      background: rgba(20, 147, 250, 0.1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      div {
        float: left;
        width: 116px;
        height: 49px;
        color: #333333;
        text-align: center;
        cursor: pointer;
      }
      .header-title {
        background: rgba(20, 147, 250, 1);
        color: #ffffff;
      }
    }
    .dialong-content {
      width: 100%;
      height: 565px;
      background: rgba(216, 216, 216, 0.28);
      margin-top: 23px;
      padding: 10px;
      img {
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/trading/invoice/invoicesAll.vue